// Angular:
import { Component, Input } from '@angular/core';

// Dependencies:
import { notNull } from '../../helpers/not-null.helper';
import { StepIndicatorItemComponent } from '../step-indicator-item/step-indicator-item.component';

@Component({
    selector: 'tm-step-indicator-step-info',
    templateUrl: 'step-indicator-step-info.component.html',
    standalone: false
})
export class StepIndicatorStepInfoComponent {
    @Input()
    public get item(): StepIndicatorItemComponent {
        return notNull(this._item, 'item');
    }
    public set item(value: StepIndicatorItemComponent) {
        this._item = value;
    }
    private _item: StepIndicatorItemComponent;
}
